import React, { Component } from 'react';
import './App.css';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import PageNotFound from './components/page_not_found'
import NavBar from './components/navbar';
import Footer from './components/footer'
import Home from './components/home'
import Trainers from './components/trainers'
import Trainer from './components/trainer'
import Explore from './components/explore'
import ViewEquipment from './components/view_equipment'
import ViewSportswearAndAccessories from './components/view_sportswear_and_accessories'
import ViewNutritionAndNutritionalPlans from './components/view_nutrition_and_nutritional_plans'
import Pricing from './components/pricing'
import About from './components/about'
import SignIn from './components/signin'
import Signup from './components/signup'
import TrainerDashboard from './components/trainer_dashboard'
import Coach from './components/coach'
import UserHome from './components/user_home'
import Method from './components/method'
import Live from './components/live'
import Terms from './components/terms'
import PrivacyPolicy from './components/privacy_policy'
import EmailVerification from './components/email_verification'
import VerifyEmail from './components/verify_email'
import ForgotPassword from './components/forgot_password'
import ResetPassword from './components/reset_password'
import FitnessPlan from './components/fitness_plan'
//// //import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
import Background_Image from './images/image_3.jpg'

class App extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };
  constructor(props) { 
    super(props);
    this.state = {

    };
  }
  componentDidMount() {

  }

  render() {
    return (
          <div className="App" style={{}}>
            <BrowserRouter>
              <NavBar/>
                <Switch>
                    <Route path='/' exact={true} component={Home}/>
                    <Route path='/trainers' exact={true} component={Trainers}/>
                    <Route path='/trainer/:trainer_id' exact={true} component={Trainer}/>
                    <Route path='/explore' exact={true} component={Explore}/>
                    <Route path='/equipment/:equipment_id' exact={true} component={ViewEquipment}/>
                    <Route path='/sportswear-and-accessories/:sportswear_and_accessory_id' exact={true} component={ViewSportswearAndAccessories}/>
                    <Route path='/nutrition-and-nutritional-plans/:nutrition_and_nutritional_plan_id' exact={true} component={ViewNutritionAndNutritionalPlans}/>
                    <Route path='/pricing' exact={true} component={Pricing}/>
                    <Route path='/about' exact={true} component={About}/>
                    <Route path='/signin' exact={true} component={SignIn}/>
                    <Route path='/terms-and-conditions' exact={true} component={Terms}/>
                    <Route path='/privacy-policy' exact={true} component={PrivacyPolicy}/>
                    <Route path='/signup/:account_type' exact={true} component={Signup}/>
                    <Route path='/signup/:account_type/:signup_type' exact={true} component={Signup}/>
                    <Route path='/dashboard' exact={true} component={TrainerDashboard}/>
                    <Route path='/dashboard/:redirect' exact={true} component={TrainerDashboard}/>
                    <Route path='/coach' exact={true} component={Coach}/>
                    <Route path='/home' exact={true} component={UserHome}/>
                    <Route path='/method/:coach_selection' exact={true} component={Method}/>
                    <Route path='/live-session/:session_id' exact={true} component={Live}/>
                    <Route path='/email-verification/:email' exact={true} component={EmailVerification}/>
                    <Route path='/verify-email/:token' exact={true} component={VerifyEmail}/>
                    <Route path='/forgot-password' exact={true} component={ForgotPassword}/>
                    <Route path='/reset-password/:token' exact={true} component={ResetPassword}/>
                    <Route path='/fitness-plan/:plan_id' exact={true} component={FitnessPlan}/>
                    <Route path="*" component={PageNotFound} />
                </Switch>
              <Footer/>
            </BrowserRouter>    
          </div>
    );
  }
}

export default withCookies(App);
